import { createI18n } from 'vue-i18n';
import en from './locales/en';
import ja from './locales/ja';
import zhTW from './locales/zh-TW';
import ko from './locales/ko';

export type SupportedLocale = 'en' | 'ja' | 'zh-TW' | 'ko';

/**
 * Detect browser locale with fallback to English
 */
export function getBrowserLocale(): SupportedLocale {
  const savedLocale = localStorage.getItem('nbc_locale') as SupportedLocale;
  if (savedLocale === 'ja' || savedLocale === 'en' || savedLocale === 'zh-TW' || savedLocale === 'ko') {
    return savedLocale;
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    const lang = navigator.language.toLowerCase();
    if (lang.startsWith('zh-tw') || lang.startsWith('zh-hk') || lang === 'zh-mo') {
      return 'zh-TW';
    }
    if (lang.startsWith('ja')) {
      return 'ja';
    }
    if (lang.startsWith('ko')) {
      return 'ko';
    }
  }

  return 'en';
}

const i18n = createI18n({
  legacy: false, // Use Vue 3 Composition API mode
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ja,
    'zh-TW': zhTW,
    ko,
  },
});

export default i18n;